import { initWorkItemsRoot } from '~/work_items';

initWorkItemsRoot();
